import React, { useState } from "react";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import {
  MDBNavbar,
  MDBNavbarNav,
  MDBNavbarItem,
  MDBNavbarLink,
  MDBNavbarToggler,
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBIcon,
  MDBBtn,
  MDBNavbarBrand,
  MDBCollapse,
} from "mdb-react-ui-kit";

import cubimg from 'images/cubimg.jpeg';
import "./BoxHomeView.css";

import { LoadingSpinner } from "Projects/CC_cubi_clan_project/GlobalComponents/LoadingSpinner/LoadingSpinner";
import { NavegadorFicheros } from "Projects/BOX_BOXconV_project/Components/NavegadorFicheros/NavegadorFicheros";

export default function BoxHomeView() {
  const [showBasic, setShowBasic] = useState(true);
  const [navActive, setNavActive] = useState("Home");
  const [isLoading, setLoading] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [cookies, setCookie] = useCookies(["miCookie"]);
  const navigate = useNavigate();

  const disconnect = () => {
    setCookie("SESSION_ID", "", { path: "/", expires: new Date(0) });
    window.location.reload();
  };

  function handleNavLinks(event) {
    if(event.target.name === "AppList"){
      navigate("/home");
    }else{
      const navLinks = document.querySelectorAll(".nav-link");
      for(let navLink of navLinks){
        navLink.classList.remove("active");
        navLink.setAttribute("aria-current", null);
      }
  
      event.target.classList.add("active");
      event.target.setAttribute("aria-current", "page");
  
      setNavActive(event.target.name);
    }
  }

  function prueba(event) {
    console.log("JRML PRUEBA");
  }

  return (
    <div className="vh-100">
      <LoadingSpinner isLoading={isLoading}/>
      <MDBNavbar expand="lg" sticky light bgColor="white">
        <MDBContainer fluid>
          <MDBNavbarBrand>
            <img src={cubimg} height="30" alt="" loading="lazy" className="me-3" />
            <div className="vr me-3" style={{ height: '40px' }}></div>
            BOX
          </MDBNavbarBrand>
          <MDBNavbarToggler
            onClick={() => setShowBasic(!showBasic)}
            data-target="#navbarRightAlignExample"
            aria-controls="navbarRightAlignExample"
            aria-expanded="false"
            aria-label="Toggle navigation"
            type="button"
          >
            <MDBIcon fas icon="bars" />
          </MDBNavbarToggler>
          <MDBCollapse navbar show={showBasic}>
            <MDBNavbarNav right fullWidth={false} className="mb-2 mb-lg-0">
              <MDBNavbarItem className="me-2">
                <MDBNavbarLink name="Home" active aria-current="page" onClick={handleNavLinks}>Box Home</MDBNavbarLink>
              </MDBNavbarItem>
              <MDBNavbarItem className="me-2">
                <MDBNavbarLink name="AppList" onClick={handleNavLinks}>Aplicaciones</MDBNavbarLink>
              </MDBNavbarItem>
              <div className="vr me-3" style={{ height: '40px' }}></div>
              <MDBNavbarItem>
                <MDBBtn onClick={disconnect} className="me-2" type="button">
                  Desconectar
                </MDBBtn>
              </MDBNavbarItem>
            </MDBNavbarNav>
          </MDBCollapse>
        </MDBContainer>
      </MDBNavbar>
      
      <MDBContainer fluid class="w-100 h-100 d-inline-block">
        <iframe src="http://localhost:8080/boxconv" className="w-100 h-100 d-inline-block" onLoad={prueba}></iframe>
      </MDBContainer>
      
    </div>
  );
}
